import { useCopyToClipboard, useNotify } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { mergeSx } from 'merge-sx';
import { memo, useMemo } from 'react';
import { IconButton } from '../icon-button';
import * as Styled from './styles';
import * as SX from './sx';
import type { CopyToClipboardProps as Props } from './types';

export const CopyToClipboard = memo(
  ({
    className,
    value,
    children,
    icon,
    iconSize,
    message,
    messagePrefix,
    sx,
    component,
  }: Props) => {
    const clip = useCopyToClipboard();
    const notify = useNotify();
    const Component = useMemo(
      () =>
        component ??
        (() => (
          <IconButton
            variant="text"
            color="default"
            icon={icon || 'copy'}
            size="xsmall"
            sx={{ fontSize: iconSize || 'inherit' }}
          >
            {children}
          </IconButton>
        )),
      [children, component, icon, iconSize]
    );
    const handleCopy = () => {
      clip
        .copy(value)
        .then(() =>
          notify.success(
            `${messagePrefix ? messagePrefix.concat(' ') : ''}${
              message || 'Successfully Copied!'
            }`
          )
        );
    };

    return (
      <Styled.Wrapper
        className={classnames('CopyToClipboard', className)}
        sx={mergeSx(SX.root, sx)}
        onClick={handleCopy}
      >
        <Component value={value}>{children || value}</Component>
      </Styled.Wrapper>
    );
  }
);

CopyToClipboard.displayName = 'CopyToClipboard';
